import { LogoRespObj } from '@models/index';
import { createAction, props } from '@ngrx/store';

export const GetEntityLogo = createAction('[CustomerLogo] Get CustomerLogos', props<{ entityId: string }>());

export const GetEntityLogoSuccess = createAction(
    '[CustomerLogo] Get CustomerLogos Success',
    props<{ data: LogoRespObj }>()
);

export const GetEntityLogoFailure = createAction('[CustomerLogo] Get CustomerLogos Failure', props<{ error: any }>());

export const GetBpEntityLogoFailure = createAction('[BpLogo] Get BpLogos Failure', props<{ error: any }>());

export const GetBpEntityLogo = createAction('[BpLogo] Get BpLogos', props<{ entityId: string }>());

export const GetBpEntityLogoSuccess = createAction('[BpLogo] Get BpLogos Success', props<{ data: LogoRespObj }>());

export const GetBpEntityLogoForCustomerFailure = createAction(
    '[BpLogo] Get BpLogo For Customer Failure',
    props<{ error: any }>()
);

export const GetBpEntityLogoForCustomer = createAction(
    '[BpLogo] Get BpLogo For Customer',
    props<{ entityId: string; uniqueId: string }>()
);

export const GetBpEntityLogoForCustomerSuccess = createAction(
    '[BpLogo] Get BpLogo For Customer Success',
    props<{ data: LogoRespObj }>()
);
